import Vue from 'vue'

Vue.$eh = Vue.prototype.$eh = new Vue()
